/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useEffect, useState } from 'react';
import {
	Button,
	Dialog,
	DialogTitle,
	DialogActions,
	DialogContent,
	CircularProgress,
	Box,
} from '@mui/material';

export const ConfirmDialog = ({
	openDialog,
	handleClose,
	handleConfirm,
	actionName,
	canBeUndone,
	additionalContent,
	title,
	confirmText,
	content,
	disabled = false,
	onClick,
	onMouseDown,
}) => {
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (openDialog) {
			setLoading(false);
		}
	}, [openDialog]);

	return (
		<Dialog
			open={openDialog}
			onClose={handleClose}
			onClick={onClick}
			onMouseDown={onMouseDown}
			hideBackdrop={true}
			sx={{ minWidth: '25%', padding: '1em' }}
		>
			<DialogTitle>{title ? title : `Confirm ${actionName}`}</DialogTitle>
			<DialogContent sx={{ paddingBottom: '2em' }}>
				{content ? (
					<>{content}</>
				) : actionName ? (
					`Are you sure you want to ${actionName}?${
						additionalContent
							? ` ${additionalContent}`
							: canBeUndone
								? ''
								: ' This cannot be undone.'
					}`
				) : (
					additionalContent || (canBeUndone ? null : 'This cannot be undone.')
				)}
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose} disabled={loading} color='primary'>
					Cancel
				</Button>
				<Button
					color='primary'
					type='submit'
					variant='contained'
					disabled={loading || disabled}
					onClick={() => {
						setLoading(true);
						handleConfirm();
					}}
				>
					{loading ? (
						<Box sx={{ padding: '0 2em' }}>
							<CircularProgress size='1em' color='white' />
						</Box>
					) : (
						(confirmText ?? 'Confirm')
					)}
				</Button>
			</DialogActions>
		</Dialog>
	);
};
